import {ValidationStatus, ValidationType} from './types';
import {Hotspot} from '@ael/core-api';

export class HotspotValidator {
  public static isValid(item: Hotspot) {
    return this.validate(item).length === 0;
  }
  public static validate(item: Hotspot): ValidationStatus[] {
    const validations = [];

    if (item.tabs.isEmpty()) {
      validations.push({
        type: ValidationType.Error,
        message: 'Missing hotspot tabs.',
        item,
        itemName: item.title ?? 'Unknown title', // This is always known!
      });
    }

    if (!item.position) {
      validations.push({
        type: ValidationType.Error,
        message: 'Missing hotspot position.',
        item,
        itemName: item.title ?? 'Unknown title', // This is always known!
      });
    }

    return validations;
  }
}
